import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide16NextSteps({
  index
}: SlideProps) {
  const steps = ['Greenlight the €3,500 Phesgo immediate fixes.', 'Confirm which additional brands to include in the annual partnership.', 'Confirm available approved Roche assets for selected brands.', 'Define first campaign topics for each brand.', 'Build first master teasers and trailers.', 'Prepare Gantt chart and country rollout timeline.', 'Align on reporting and optimization rhythm.'];
  return <InteriorSlide surface data-id="element-330">
      <SlideHeader eyebrow="Next Steps" data-id="element-331">Proposed next steps</SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-4xl mx-auto w-full" data-id="element-332">
        <div className="bg-white rounded-3xl shadow-sm border border-black/5 p-8 md:p-12" data-id="element-333">
          <div className="space-y-6" data-id="element-334">
            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.3 + i * 0.1,
            duration: 0.5
          }} className="flex items-start gap-4 group" data-id="element-335">
                <div className="mt-1 h-6 w-6 rounded-full bg-[var(--surface)] flex items-center justify-center flex-shrink-0 group-hover:bg-[var(--brand)] transition-colors" data-id="element-336">
                  <CheckCircle2 className="h-4 w-4 text-[var(--brand)] group-hover:text-white transition-colors" data-id="element-337" />
                </div>
                <p className="text-[clamp(1.1rem,1.3vw,1.2rem)] text-[var(--fg)] font-medium leading-relaxed" data-id="element-338">
                  {step}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </InteriorSlide>;
}